<script setup lang="ts">
import { computed } from 'vue';
import { ICONS, type IconName } from '@/libs/icons';

const props = withDefaults(
  defineProps<{
    name: IconName;
    /** Any CSS length; a bare number is read as pixels */
    size?: number | string;
    strokeWidth?: number;
  }>(),
  {
    // `1em` lets the surrounding `font-size` drive the size, the way the icon
    // fonts this replaced were sized.
    size: '1em',
    strokeWidth: 2,
  },
);

const paths = computed(() => ICONS[props.name]);
const length = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size));
</script>

<template>
  <svg
    class="base-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="length"
    :height="length"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <component :is="tag" v-for="([tag, attrs], index) in paths" :key="index" v-bind="attrs" />
  </svg>
</template>

<style lang="scss">
.base-icon {
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
}
</style>
